import { render } from "./account-setting.vue?vue&type=template&id=54f14aa4"
import script from "./account-setting.vue?vue&type=script&lang=js"
export * from "./account-setting.vue?vue&type=script&lang=js"

import "./account-setting.vue?vue&type=style&index=0&id=54f14aa4&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__